import 'normalize.css';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/table/style/css';
import 'element-plus/es/components/table-column/style/css';
import 'element-plus/es/components/table-v2/style/css';
import 'element-plus/es/components/form/style/css';
import 'element-plus/es/components/form-item/style/css';
import '@/styles/index.sass';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as ElementIcons from '@element-plus/icons-vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import EcoAuthClientPlugin from '@onetech/eco-auth-client-vue';

import * as piniaStore from '@/store';
import { debounce } from 'es-toolkit';
import App from './App.vue';
import { createRouter } from './router';
import { vueQueryConfig } from './config/vue-query.config';
import { useConfig } from './config/config';

// Below code to solve issue related to
// Error: ResizeObserver loop completed with undelivered notifications
// fix: https://github.com/vuejs/vue-cli/issues/7431
const _ = (window as any).ResizeObserver;

(window as any).ResizeObserver = class ResizeObserver extends _ {
  constructor(callback: (...args: any[]) => void) {
    // eslint-disable-next-line no-param-reassign
    callback = debounce(callback, 20);

    super(callback);
  }
};

const main = async () => {
  const pinia = createPinia();

  const router = createRouter(piniaStore);

  const config = useConfig();
  const app = createApp(App);

  try {
    const ecoAuth = await EcoAuthClientPlugin({
      apiPrefix: config.ecoAuthApiPrefix,
    });
    app.use(ecoAuth);
  } catch (e) {
    console.error(e);

    const root = document.getElementById('app');
    if (root) {
      root.innerHTML = `
        <div style="padding: 20px; color: #b91c1c">
          <p>Probably ECO auhentication service is unavailable. Please, try again in a few minutes.</p>
          <p>${e}</p>
        </div>
      `;
    }

    throw e;
  }

  app
    .use(VueQueryPlugin, vueQueryConfig)
    .use(pinia)
    .use(router);

  for (const iconKey of Object.keys(ElementIcons)) {
    // @ts-expect-error разрабы либы не вывели удобно тип
    app.component(ElementIcons[iconKey].name, ElementIcons[iconKey]);
  }

  app.mount('#app');
};

main().catch(console.error);
